import { isResponseError } from 'up-fetch'

import { type IInquiryDocumentUpload, type IUnassignedDocument } from '../types'
import { useUpFetch } from '../utils'

export const useDocumentApi = () => {
  const upFetch = useUpFetch()

  const uploadUnassignedDocument = async (document: IInquiryDocumentUpload) => {
    const formData = new FormData()

    formData.append('type', document.type ?? 'other')
    formData.append('files[]', document.file)

    try {
      const response = await upFetch<{
        data: IUnassignedDocument[]
      }>('/loads/documents/unassigned', {
        body: formData,
        method: 'POST',
      })

      return response.data
    } catch (error: unknown) {
      if (isResponseError(error)) {
        console.error(error)
      }

      console.error(error)
      throw new Error('Failed to upload document')
    }
  }

  const assignDocumentsToLoad = async (
    loadId: number,
    documents: IInquiryDocumentUpload[] | IUnassignedDocument[],
  ) => {
    if (!documents.length) return
    try {
      await upFetch(`/loads/${loadId}/documents/assign`, {
        body: {
          document_ids: documents.map(doc => doc.id),
        },
        method: 'POST',
      })
    } catch (error: unknown) {
      console.error(error)
      throw new Error('Failed to assign documents to load')
    }
  }

  const updateDocumentType = async (documentId: number, type: IInquiryDocumentUpload['type']) => {
    try {
      return await upFetch(`/loads/documents/unassigned/${documentId}`, {
        body: {
          type: type,
        },
        method: 'PATCH',
      })
    } catch (error: unknown) {
      console.error(error)
      throw new Error('Failed to assign documents to load')
    }
  }

  return { assignDocumentsToLoad, updateDocumentType, uploadUnassignedDocument }
}
